import { MetaKey, Shortcut } from './shortcut.model';

const MAC_META_KEYS_MAP: Record<MetaKey, string> = {
  alt: '⌥',
  cmd: '⌘',
  ctrl: '⌘',
  shift: '⇧',
};
// [string, string?] - MacOS, Windows
const PREDEFINED_LABELS: Partial<Record<Shortcut, [string, string?]>> = {
  delete: ['⌘Delete'],
  'shift+f': ['Shift + F'],
};

export function getShortcutLabel(shortcut: Shortcut): string {
  const isMacOS = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
  const predefinedLabels = PREDEFINED_LABELS[shortcut];

  return isMacOS
    ? predefinedLabels?.[0] ?? getMacLabel(shortcut)
    : predefinedLabels?.[1] ?? getWinLabel(shortcut);
}

function getMacLabel(shortcut: Shortcut): string {
  return shortcut
    .split('+')
    .map((str) => {
      return MAC_META_KEYS_MAP[str as MetaKey] ?? str.charAt(0).toUpperCase() + str.slice(1);
    })
    .join('');
}

function getWinLabel(shortcut: Shortcut): string {
  return shortcut
    .split('+')
    .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
    .join(' + ');
}
